import { IconifyIcon } from 'iconify-icon'

export const IconMenuCharacters: IconifyIcon = {
	'body': '<svg xmlns="http://www.w3.org/2000/svg" width="56.502" height="79.473" viewBox="0 0 56.502 79.473"><g fill="currentColor" transform="translate(-.162)"><path d="M.177,79.473s-1.59-39.891,28.772-40,27.654,40,27.654,40Z"/><ellipse cx="15.269" cy="15.243" rx="15.269" ry="15.243" transform="translate(13.062)"/></g></svg>',
	'width': 56.502,
	'height': 79.473,
}
export default IconMenuCharacters
